// extracted by mini-css-extract-plugin
export var danger = "RichTextField-module--danger--66d09";
export var heading = "RichTextField-module--heading--1997b";
export var listItem = "RichTextField-module--listItem--4da67";
export var neutral = "RichTextField-module--neutral--06891";
export var noteWrapper = "RichTextField-module--noteWrapper--adb35";
export var success = "RichTextField-module--success--780cc";
export var warning = "RichTextField-module--warning--31ff2";